import { BaseEntity } from 'src/app/entities/base-entity/base-entity';

/**
 * Class that represents a tag in the tracking system.
 *
 * @class Tag
 */
export class Tag extends BaseEntity {
  /**
   * Creates an instance of a Tag.
   *
   * @param {string} _uuid
   *   A unique identifier for the tag. If not provided it will be
   *   autogenerated.
   * @param {string} _label
   *   A simple label for the tag.
   */
  constructor(
    _uuid: string,
    protected _label: string,
  ) {
    super(_uuid);
  }

  get label(): string {
    return this._label;
  }
}
